module.exports = __webpack_public_path__ + "static/media/contact-email.28b754ba.svg";